module.exports = __webpack_public_path__ + "static/empty-states-single-empty-states-do-ae3f2fb6d53a90216f6e28bb5801017e.png";